import {Component, EventEmitter, OnDestroy, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {Store} from '@ngrx/store';
import {Subject} from 'rxjs';
import {FileManagerLocation} from '../../../models/file-manager.model';
import {CellComponent} from '@shared/components/cell-components/cell-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {ParticleState} from '@shared/store/reducers/particle.reduer';
import {FieldDefinition} from '@shared/models/field-definition';

@Component({
    standalone: false,
    selector: 'lib-file-name-cell-viewer',
  templateUrl: './file-name-cell-viewer.component.html',
  styleUrls: ['./file-name-cell-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FileNameCellViewerComponent implements OnInit, OnDestroy, CellComponent {
  @Output() valueChanged: EventEmitter<any> = new EventEmitter();
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;
  currentLocation: FileManagerLocation;
  private ngUnsubscribe = new Subject<void>();
  disabled: boolean;

  constructor(private store: Store<ParticleState>) { }

  ngOnInit() {
  }

  onClickFileName($event) {
    if (!$event.item.cells['IsDeleted']?.value) {
      this.valueChanged.emit($event);
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  markStar() {
    if (!this.item.cells['IsDeleted']?.value) {
      const payload = {
        item: this.item,
        fieldDefinition: this.fieldDefinition,
        action: {
          disabled: false,
          id: 'MarkStar',
          isCustom: false,
          tags: ['CanView'],
          text: 'MarkStar'
        }
      };
      this.valueChanged.emit(payload);
    }
  }
}
